export const PAGE_GATE_TYPES = ['ageGate', 'contactCollection']
